import React from "react";
import "./Loading.css";
import loadimg from "../Assests/Images/NCLogoLoading.png";
const Loading = () => {

    return (
        <>
            <div className="MainLoading">
                <div className="CircleRotate">
                    <img src={loadimg} alt="Loading..." />
                </div>
                   <span style={{color:"white"}}> Loading... </span>
            </div>
            {/* <span className="Loading">
        
        <img src={loadimg} alt="Loading..."/>
         Loading...
         </span> */}
        </>
    )
};
export default Loading;